/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A time interval to group meter value data by (optional; default='1m').
 */
export var intervalPeriod;
(function (intervalPeriod) {
    intervalPeriod["_1M"] = "1m";
    intervalPeriod["_2M"] = "2m";
    intervalPeriod["_5M"] = "5m";
})(intervalPeriod || (intervalPeriod = {}));
